import { createApp } from 'vue'
import App from './App.vue'
import i18n from "@/i18n";
import router from "@/router/router";
import axios from 'axios'
import store from "@/store/store";
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import util from "@/util/util";
import "@/util/commom.css"

let app = createApp(App);

app.config.globalProperties.$axios = axios;

// axios.defaults.baseURL = "http://localhost:8848/test/";
axios.defaults.baseURL = "";

axios.interceptors.response.use(response =>{
    return response;
},error => {
    console.log(error);
    if (error.response){
        switch (error.response.status) {
            case 401:
                var currentUrl = encodeURIComponent(util.localUrl);
                window.location.href = util.casLoginUrl + currentUrl;
                break;
            default:
                break;
        }
    }
});


app.use(router).use(i18n).use(store).use(Antd);
router.isReady().then(() => app.mount('#app'))

